import React, { FC } from 'react';

import PledgePink from '@images/pledge-pink.png';
import PledgeCyan from '@images/pledge-cyan.png';
import PledgeYellow from '@images/pledge-yellow.png';
import PledgeOrange from '@images/pledge-orange.png';
import PledgeAnimated from '@images/pledge_2023.gif';

const IconTable = [
  { name: 'Pink', icon: PledgePink, r: 255, g: 70, b: 255 },
  { name: 'Cyan', icon: PledgeCyan, r: 46, g: 255, b: 228 },
  { name: 'Yellow', icon: PledgeYellow, r: 255, g: 255, b: 0 },
  { name: 'Orange', icon: PledgeOrange, r: 255, g: 180, b: 0 },
];

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function findClosestIcon(r: number, g: number, b: number) {
  const rgb = { r: r, g: g, b: b };
  let delta = 3 * 256 * 256;
  let match = IconTable[0];

  for (let i = 0; i < IconTable.length; i++) {
    const icon = IconTable[i];
    if (
      Math.pow(icon.r - rgb.r, 2) +
        Math.pow(icon.g - rgb.g, 2) +
        Math.pow(icon.b - rgb.b, 2) <
      delta
    ) {
      delta =
        Math.pow(icon.r - rgb.r, 2) +
        Math.pow(icon.g - rgb.g, 2) +
        Math.pow(icon.b - rgb.b, 2);
      match = icon;
    }
  }
  return match;
}

interface PollPledgeIconProps {
  color: string | 'animated';
}

const PollPledgeIcon: FC<PollPledgeIconProps> = ({ color }) => {
  if (color === 'animated') {
    return <img src={PledgeAnimated} alt="pledge" />;
  } else {
    let rgb;
    if (color.startsWith('#')) rgb = hexToRgb(color);
    else if (color.startsWith('rgb(')) {
      const rgbArr = color.replace(/[^\d,]/g, '').split(',');
      if (rgbArr && rgbArr.length >= 3)
        rgb = { r: rgbArr[0], g: rgbArr[1], b: rgbArr[2] };
    }
    if (!rgb) rgb = { r: 0, g: 0, b: 0 };
    const pledgeIcon = findClosestIcon(rgb.r, rgb.g, rgb.b);
    return <img src={pledgeIcon.icon} alt="pledge" />;
  }
};

export default PollPledgeIcon;
